import URL_ROUTE from "../constants/index.js";
import request from "../configs/AxiosWrapper.js";
import { toast } from "react-toastify";

const token = sessionStorage.getItem("token");

const OperacionesService = () => {
  const createOperation = async (data) => {
    return await request(URL_ROUTE.CREATEOPERACION, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        ...data,
        ID_TIPO_DE_OPERACION: parseInt(data.ID_TIPO_DE_OPERACION),
      }),
    });
  };

  const getFiltro = async (data) => {
    return await request(URL_ROUTE.GETFILTRO, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });
  };

  const getOperacionForUUID = async (UUID) => {
    return await request(URL_ROUTE.getOperacionForUUID, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ UUID }),
    });
  };

  const getOperacionForUUID2 = async (UUID) => {
    return await request(URL_ROUTE.GETOPERACIONFORUUID2, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ UUID }),
    });
  };

  const CCDS_SP_ELIMINA_REGISTRO = async (UUID) => {
    return await request(URL_ROUTE.CCDS_SP_ELIMINA_REGISTRO, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ GUID: UUID }),
    });
  };

  const reporteDiario = async (data) => {
    return await request(URL_ROUTE.GETREPORTEDIARIO, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });
  };

  const reporteDiarioExcel = async (DATA) => {
    try {
      const response = await request(URL_ROUTE.GETREPORTEDIARIOEXCEL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob", 
        body: JSON.stringify(DATA),
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement("a");
      a.href = url;
      a.download = "reporte_diario.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (error) {
      console.error(error.message);
      throw error;
    }
  };

  const desprendiblePagoAux = async ({FECHA_INICIO, FECHA_FIN, ID_PLANTA}, usuariosNotificables) => {
    return await request(URL_ROUTE.DESPRENDIBLEPAGOAUX, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({FECHA_INICIO, FECHA_FIN, PLANTA: ID_PLANTA, USUARIOS: usuariosNotificables}),
    });
  };

  
  const fitroAgendaPlaca = async ({ DATA, FECHA_INICIO, FECHA_FIN }) => {
    try {
      const response = await fetch(URL_ROUTE.FITROAGENDAPLACA, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ DATA, FECHA_INICIO, FECHA_FIN }),
      });
  
      if (!response.ok) {
        throw new Error("Error en la descarga del archivo");
      }
  
      const blob = await response.blob();
      
      if (blob.size === 0 || blob.size <= 70) {
        toast.error(response?.message || "No existen placas inexistentes en base de datos");
        return;
      }
  
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "desprendible_pago_auxiliar.xlsx";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error al descargar el archivo:", error);
      toast.error("Error al descargar el archivo.");
    }
  };


  const recuperarAuxiliaresPorCedulas = ({FECHA_INICIO, FECHA_FIN, PLANTA}) => {
    return request(URL_ROUTE.RECUPERARAUXILIARESPORCEDULAS, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({FECHA_INICIO, FECHA_FIN, PLANTA}),
    });
  }

  const desprendiblePagoAuxPorCedula = ({FECHA_INICIO, FECHA_FIN, PLANTA, NUMERO_IDENTIFICACION}) => {
    return request(URL_ROUTE.DESPRENDIBLEPAGOAUXPORCEDULA, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({FECHA_INICIO, FECHA_FIN, PLANTA, NUMERO_IDENTIFICACION}),
    });
  }
  

  return {
    createOperation,
    getFiltro,
    getOperacionForUUID,
    CCDS_SP_ELIMINA_REGISTRO,
    getOperacionForUUID2,
    reporteDiario,
    reporteDiarioExcel,
    desprendiblePagoAux,
    fitroAgendaPlaca,
    recuperarAuxiliaresPorCedulas,
    desprendiblePagoAuxPorCedula
  };
};

export default OperacionesService;
